import {Booking} from "../../../../core/entities/booking/domain/models/booking.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingDeactivatedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'BookingDeactivatedEvent';

  constructor(public readonly booking: Booking | null = null) {
  }
}
